export default function HeaderStrip() {
  return (
    <div className="w-full bg-[#047857] text-white py-3 px-4 md:px-6">
      <div className="max-w-7xl mx-auto flex items-center justify-between text-sm">
        <nav className="flex items-center gap-2">
          <a href="/" className="hover:underline opacity-90">Home</a>
          <span className="opacity-60">&gt;</span>
          <span className="opacity-90">Services</span>
          <span className="opacity-60">&gt;</span>
          <span className="font-medium">Glass Replacement</span>
        </nav>
        <span className="hidden sm:inline font-medium">Non-Impact Only</span>
      </div>
    </div>
  );
}